import { TLabel } from "../../../../shared/interface/label";
import { IDiseaseDto } from "../dtos/diseases";

export class Disease {
  readonly id: string;
  name: string;
  biologicalGroup: string;
  latinName: string;
  imageUrl?: string;
  isDeleted?: boolean;

  constructor(id: string) {
    this.id = id;
  }

  get asDto(): IDiseaseDto {
    return {
      id: this.id,
      name: this.name,
      biologicalGroup: this.biologicalGroup,
      latinName: this.latinName,
      imageUrl: this.imageUrl,
    };
  }

  updateFromDto(dto: IDiseaseDto): void {
    this.name = dto.name;
    this.biologicalGroup = dto.biologicalGroup;
    this.latinName = dto.latinName;
    this.imageUrl = dto.imageUrl;
    this.isDeleted = dto.isDeleted;
  }

  get asViolationType(): TLabel {
    return {
      id: this.id,
      title: this.name,
    };
  }
}
